export const getTimeFromDateTime = date => {
  let hours = date.getHours();
  const AmOrPm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;
  const minutes = date.getMinutes();
  return `${hours}:${minutes} ${AmOrPm}`;
};
